// import react
import React from 'react';

// import hooks
import { Controller, useFormContext } from 'react-hook-form';

// import components
import ColorPickerPopover from '../ColorPickerPopover/ColorPickerPopover';

// import types
import { HexColor } from '../ColorPickerPopover/ColorPickerPopover.types';
import { ControlledColorPickerPopoverProps } from './ControlledColorPickerPopover.types';

export const ControlledColorPickerPopover: React.FC<
  ControlledColorPickerPopoverProps
> = ({ label, name }) => {
  const { control, setValue } = useFormContext();

  function onColorSelect(color: HexColor) {
    setValue(name, color, { shouldDirty: true });
  }

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <ColorPickerPopover
            color={field.value}
            onColorSelected={onColorSelect}
            hasEditFeature={true}
            label={label}
          />
        </div>
      )}
    />
  );
};
